import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

export default function KeyboardDatePickerInput(props) {

  const { label, errors, variant, ...mobileDatePickerProps } = props;

  return (
    <FormControl fullWidth>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MobileDatePicker
          closeOnSelect
          format="MM/dd/yyyy"
          slotProps={{
            actionBar: {
              actions: ['cancel', 'accept',],
            },
            textField: {
              variant: variant || "standard",
              error: !!errors,
              helperText: errors?.message,
              label: label,
              fullWidth: true,
            },
            openPickerButton: {
              'aria-label': `change date for ${label}`,
            },
          }}
          {...mobileDatePickerProps}
        />
      </LocalizationProvider>
    </FormControl>
  )
}

KeyboardDatePickerInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  errors: PropTypes.object,
};
